module.exports = __webpack_public_path__ + "img/null.5109c00f.png";